import IInitiativeSubmissionData from 'types/IInitiativeSubmissionData'
import { IInitiativeAnswerData } from '../Interfaces'
import { ValidationErrorResult } from './State'

export const SET_INITIATIVE_DATA = 'initiativeSubmissionComponent.setInitiativeData'
export const SET_IS_LOADING_INITIATIVE_DATA = 'initiativeSubmissionComponent.setIsLoadingInitiativeData'
export const SET_IS_SAVING_INITIATIVE_DATA = 'initiativeSubmissionComponent.setIsSavingInitiativeData'
export const SET_GPA_GRADE = 'initiativeSubmissionComponent.setGpaGrade'
export const SET_GPA_VALUE = 'initiativeSubmissionComponent.setGpaValue'
export const SET_QUESTION_ANSWER = 'initiativeSubmissionComponent.setQuestionAnswer'
export const SET_LAST_AUTO_SAVE_DATE = 'initiativeSubmissionComponent.setLastAutoSaveSate'
export const SET_CURRENT_DATE_TIME = 'initiativeSubmissionComponent.setCurrentDateTime'
export const SET_ANSWERS_STATE = 'initiativeSubmissionComponent.setAnswersState'
export const SET_VALIDATION_ERROR = 'initiativeSubmissionComponent.setValidationError'
export const SET_IS_SUBMITTING = 'initiativeSubmissionComponent.setIsSubmitting'
export const SET_IS_SUCCESS_DIALOG_OPEN = 'initiativeSubmissionComponent.isSuccessDialogOpen'
export const SET_IS_INCOMPLETE_PROFILE_DIALOG_OPEN = 'initiativeSubmissionComponent.isIncompleteProfileDialogOpen'
export const COMPLETE_INITIATIVE_LOADING = 'initiativeSubmissionComponent.completeInitiativeDataLoading'
export const RESET = 'initiativeSubmissionComponent.reset'
export const SET_VALIDATION_STATE = 'initiativeSubmissionComponent.setValidationState'

export function setInitiativeData(payload: IInitiativeSubmissionData) {
  return {
    type: SET_INITIATIVE_DATA,
    payload
  } as const
}

export function setIsLoadingInitiativeData(payload: boolean) {
  return {
    type: SET_IS_LOADING_INITIATIVE_DATA,
    payload
  } as const
}

export function setIsSavingInitiativeData(payload: boolean) {
  return {
    type: SET_IS_SAVING_INITIATIVE_DATA,
    payload
  } as const
}

export function setGpaGrade(payload: 'GRADUATE' | 'UNDERGRADUATE' | 'DOES_NOT_APPLY' | null) {
  return {
    type: SET_GPA_GRADE,
    payload
  } as const
}

export function setGpaValue(payload: number) {
  return {
    type: SET_GPA_VALUE,
    payload
  } as const
}

export function setQuestionAnswer(questionId: number, answer: string) {
  return {
    type: SET_QUESTION_ANSWER,
    payload: {
      [questionId]: { answer }
    }
  } as const
}

export function setQuestionChoice(questionId: number, choices: number[]) {
  return {
    type: SET_QUESTION_ANSWER,
    payload: {
      [questionId]: { choices }
    }
  } as const
}

export function setLastAutoSaveDate(payload: string) {
  return {
    type: SET_LAST_AUTO_SAVE_DATE,
    payload
  } as const
}

export function setCurrentDateTime(payload: string) {
  return {
    type: SET_CURRENT_DATE_TIME,
    payload
  } as const
}

export function setAnswersState(payload: IInitiativeAnswerData) {
  return {
    type: SET_ANSWERS_STATE,
    payload
  } as const
}

export function setValidationError(payload: boolean) {
  return {
    type: SET_VALIDATION_ERROR,
    payload
  } as const
}

export function setIsSubmitting(payload: boolean) {
  return {
    type: SET_IS_SUBMITTING,
    payload
  } as const
}

export function setIsSuccessDialogOpen(payload: boolean) {
  return {
    type: SET_IS_SUCCESS_DIALOG_OPEN,
    payload
  } as const
}

export function setIsIncompleteProfileDialogOpen(payload: boolean) {
  return {
    type: SET_IS_INCOMPLETE_PROFILE_DIALOG_OPEN,
    payload
  } as const
}

export function completeInitiativeDataLoading(
  initiativeData: IInitiativeSubmissionData,
  answers: IInitiativeAnswerData
) {
  return {
    type: COMPLETE_INITIATIVE_LOADING,
    payload: {
      initiativeData,
      answers,
      isLoadingInitiative: false
    }
  } as const
}

export function setValidationState(payload: { [key: string]: ValidationErrorResult }) {
  return {
    type: SET_VALIDATION_STATE,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type InitiativeSubmissionAction = ReturnType<
  | typeof setInitiativeData
  | typeof setIsLoadingInitiativeData
  | typeof setIsSavingInitiativeData
  | typeof setGpaGrade
  | typeof setQuestionAnswer
  | typeof setQuestionChoice
  | typeof setGpaValue
  | typeof setLastAutoSaveDate
  | typeof setCurrentDateTime
  | typeof setAnswersState
  | typeof setValidationError
  | typeof setIsSubmitting
  | typeof setIsSuccessDialogOpen
  | typeof setIsIncompleteProfileDialogOpen
  | typeof completeInitiativeDataLoading
  | typeof reset
  | typeof setValidationState
>
